import { Button, Heading, Icon, Input } from "@elaniintc/goes-design-system";
import { Skeleton } from "@/components/ui/skeleton";

interface DetailHeaderProps {
  canUpdateTable: boolean;
  isLoading: boolean;
  title: string;
  description: string;
  search: string;
  onSearchChange: (value: string) => void;
  canCreateRegistry: boolean;
  onNewRow: () => void;
  isNewRowDisabled: boolean;
  onEditTable: () => void;
}

export const DetailHeader = ({
  canUpdateTable,
  isLoading,
  title,
  description,
  search,
  onSearchChange,
  canCreateRegistry,
  onNewRow,
  isNewRowDisabled,
  onEditTable,
}: DetailHeaderProps) => {
  return (
    <div className="flex justify-between items-start gap-3 border-b border-neutral w-full p-3">
      <div className="flex justify-start gap-2.5 items-center flex-auto truncate">
        {canUpdateTable && (
          <Button
            data-testid="edit-table-button"
            size="default"
            variant="quiet"
            onClick={onEditTable}
          >
            <Icon type="far" name="edit" className="text-current" />
          </Button>
        )}
        {isLoading ? (
          <div className="flex flex-col">
            <Skeleton className="h-4 w-48 mb-2" />
            <Skeleton className="h-3 w-64" />
          </div>
        ) : (
          <div className="flex flex-col justify-center max-h-10 truncate w-full">
            <Heading
              variant="h6"
              className="text-body-loud w-full truncate"
              title={title}
            >
              {title}
            </Heading>
            <p
              className="text-body-quiet -translate-y-0.75 text-sm w-full truncate"
              title={description}
            >
              {description}
            </p>
          </div>
        )}
      </div>
      <div className="flex items-center gap-2 h-10">
        <div className="relative">
          <Icon
            type="far"
            name="search"
            className="absolute left-2 top-1/2 transform -translate-y-1/2 text-body text-sm"
          />
          <Input
            variant="xs"
            placeholder="Buscar..."
            className="h-8 w-50 pl-8"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        {canCreateRegistry && (
          <Button
            variant="default"
            size="xs"
            onClick={onNewRow}
            disabled={isNewRowDisabled}
          >
            Nuevo <Icon type="far" name="plus" className="text-current" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default DetailHeader;
